import React from 'react';
import { HeaderHeights, Header, MainWrapperForNavigation } from 'mm-ui-components';
import { MainWrapperConfigThemeKey } from 'mm-ui-components/dist/src/base/wrappers/mainWrapper/mainWrapper.theme';
import { useSelector } from 'react-redux';
import { FooterConnected } from './FooterConnected';
import { getHeader, getSubHeader } from '../../store/navigations/navigation/header/header.selectors';
import { getMenu } from '../../store/navigations/navigation/menu/menu.selectors';
import { getEditionEndpoint, getPagePath } from '../../store/config/config.selectors';

interface NavigationLayoutProps {
  mainWrapperConfigThemeKey: MainWrapperConfigThemeKey;
}

const HeaderConnected: React.FunctionComponent = () => {
  const header = useSelector(getHeader);
  const menu = useSelector(getMenu);
  const pagePath = useSelector(getPagePath);
  const editionEndpoint = useSelector(getEditionEndpoint);
  return <Header {...header} menu={menu} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
};

export const NavigationLayout: React.FunctionComponent<NavigationLayoutProps> = props => {
  const { children, mainWrapperConfigThemeKey } = props;
  const doesSubHeaderExist = !!useSelector(getSubHeader);
  return (
    <HeaderHeights doesSubHeaderExist={doesSubHeaderExist}>
      <HeaderConnected />
      <MainWrapperForNavigation configThemeKey={mainWrapperConfigThemeKey}>
        {children}
      </MainWrapperForNavigation>
      <FooterConnected />
    </HeaderHeights>
  );
};
